import './../../../Styles/vars.css';
import './../../../Styles/containers.css';
import './../../../Styles/elements.css';
import { isMobile, isTablet } from 'react-device-detect';
import { FaClipboardCheck, FaHome } from 'react-icons/fa';
import ChecklistViajeCatalog from './ChecklistViajeCatalog';

export default function ChecklistViajePage() {
    const isSmall = isMobile || isTablet;

    return (
        <div className="panel-sigma-layout">
            <aside className={`panel-sigma-sidebar ${isSmall ? 'panel-sigma-sidebar-responsive' : ''}`}>
                {!isSmall && (
                    <div className="panel-sigma-avatar">
                        <FaClipboardCheck size={48} />
                    </div>
                )}
                <nav className="panel-sigma-nav">
                    <button title="Inicio"><FaHome /></button>
                </nav>
            </aside>

            <ChecklistViajeCatalog />
        </div>
    );
}
